import { Link } from 'react-router-dom';
import { C, SectionLabel, H2, wrap } from './styles';
import Nav from './components/Nav';
import Footer from './components/Footer';
import { posts } from './blog/posts';
import { useDocumentMeta } from './blog/useDocumentMeta';

const PAGE_TITLE = 'Blog | MetalMatch';
const PAGE_DESCRIPTION = 'Practical guides on custom metal fabrication, pricing, and prototyping for anyone sourcing parts in Ontario.';

export default function Blog() {
  useDocumentMeta(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <>
      <Nav />
      <section style={{ padding: '80px 0 90px' }}>
        <div style={wrap}>
          <SectionLabel>Blog</SectionLabel>
          <H2 style={{ maxWidth: 620, marginBottom: 18 }}>Guides on sourcing custom metal parts</H2>
          <p style={{ color: C.mut, fontSize: 16, lineHeight: 1.75, maxWidth: 560, marginBottom: 48 }}>
            {PAGE_DESCRIPTION}
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {posts.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} style={{ textDecoration: 'none' }}>
                <div style={{
                  background: C.surf, border: `1px solid ${C.bdr}`, borderRadius: 10,
                  padding: '26px 28px', transition: 'border-color 0.2s',
                }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = C.navy}
                  onMouseLeave={e => e.currentTarget.style.borderColor = C.bdr}
                >
                  <h3 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 24, fontWeight: 700, textTransform: 'uppercase', color: C.txt, marginBottom: 8 }}>
                    {p.title}
                  </h3>
                  <p style={{ color: C.mut, fontSize: 14, lineHeight: 1.7, marginBottom: 10 }}>{p.description}</p>
                  <span style={{ fontSize: 12, fontWeight: 600, color: C.orange }}>Read {p.kind || 'guide'} →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
